<template>
  <div class="benefits-section">
    <h2>Why Partner With Us?</h2>
    <div class="benefits-grid">
      <div
        class="benefit-card"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-once="true"
      >
        <div class="icon">
          <RiSmartphoneLine size="36" />
        </div>
        <h3>No Equipment Needed</h3>
        <p>Create premium 360° tours directly with your smartphone</p>
      </div>
      <div
        class="benefit-card"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
        data-aos-once="true"
      >
        <div class="icon">
          <RiMoneyEuroCircleLine size="36" />
        </div>
        <h3>Earn More</h3>
        <p>
          Earn $100-$10K monthly by selling 360° photography to your clients
        </p>
      </div>
      <div
        class="benefit-card"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="200"
        data-aos-once="true"
      >
        <div class="icon">
          <RiLineChartLine size="36" />
        </div>
        <h3>Upsell Services</h3>
        <p>
          Expand your photography services by offering immersive 360°
          experiences
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  RiLineChartLine,
  RiMoneyEuroCircleLine,
  RiSmartphoneLine,
} from "@remixicon/vue";
const { $Aos } = useNuxtApp();
onMounted(() => {
  $Aos.init();
});
</script>

<style lang="scss" scoped>
.benefits-section {
  padding: 6rem 2rem;

  @include respond-below(sm) {
    padding: 4rem 1rem;
  }

  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 39px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.9);
    font-family: "Manrope", sans-serif;
    text-align: center;
    margin-bottom: 2rem;

    @include respond-below(sm) {
      font-size: 28px;
    }
  }

  .benefits-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    max-width: 1200px;
    margin: 0 auto;

    @include respond-below(lg) {
      grid-template-columns: repeat(2, 1fr);
    }

    @include respond-below(sm) {
      grid-template-columns: 1fr;
    }

    .benefit-card {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 12px;
      padding: 2rem;
      text-align: center;
      transition: transform 0.3s ease, box-shadow 0.3s ease;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 30px rgba(158, 8, 97, 0.1);
      }

      .icon {
        background: rgba(255, 255, 255, 0.1);
        width: 70px;
        height: 70px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 1.5rem;

        svg {
          color: rgba(255, 255, 255, 0.4);
        }
      }

      h3 {
        font-size: 20px;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.9);
        margin-bottom: 1rem;
      }

      p {
        font-size: 16px;
        line-height: 1.6;
        color: rgba(255, 255, 255, 0.4);
      }
    }
  }
}
</style>
